const mutations = {
	['UPDATE_USER_INFO'] (state, userInfo) {
		state.nickname = userInfo.nickname || '';
		state.userId = userInfo.userId || '';
		state.balance = userInfo.balance || 0;
		state.credits = userInfo.credits || 0;
		state.avatar = userInfo.avatar || '';
	},
};

export default mutations;